// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: 1026312653
// </auto-generated>
import {
  StringLength,
  RegularExpression,
  Required,
  EmailAddress,
  MinValue,
} from 'carehub-shared/validators';

export class DismissNotificationsRequest {
  ids: any[];
}

export function initializeNewDismissNotificationsRequest(): DismissNotificationsRequest {
  const instance = new DismissNotificationsRequest();
  instance.ids = null;
  return instance;
}
